import React, { useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import "./AdminCommissions";

/* ================= CONSTANT ================= */
const COMMISSION_START_DATE = new Date("2026-01-12T00:00:00");

/* ================= HELPERS ================= */
const isToday = (date) => {
  const now = new Date();
  return (
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear()
  );
};

const joinedAfterStart = (user) => {
  if (!user?.createdAt?.seconds) return false;
  return new Date(user.createdAt.seconds * 1000) >= COMMISSION_START_DATE;
};

/* ================= COMPONENT ================= */
const AdminTeamProfitSearch = () => {
  const [username, setUsername] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSearch = async () => {
    if (!username) return;

    setLoading(true);
    setError("");
    setResult(null);

    try {
      /* ===== LOAD USERS ===== */
      const usersSnap = await getDocs(collection(db, "users"));
      const users = usersSnap.docs.map(d => ({ id: d.id, ...d.data() }));

      const me = users.find(u => u.username === username);
      if (!me || !me.referralCode) {
        setError("Mtumiaji hakupatikana au hana referral code");
        setLoading(false);
        return;
      }

      /* ===== LEVELS (AFTER 12/01/2026) ===== */
      const level1 = users.filter(
        u => u.whoReferredWho === me.referralCode && joinedAfterStart(u)
      );

      const level2 = users.filter(
        u =>
          level1.map(l1 => l1.referralCode).includes(u.whoReferredWho) &&
          joinedAfterStart(u)
      );

      const level3 = users.filter(
        u =>
          level2.map(l2 => l2.referralCode).includes(u.whoReferredWho) &&
          joinedAfterStart(u)
      );

      /* ===== WON BETS (LEO TU) ===== */
      const betsSnap = await getDocs(
        query(collection(db, "userBets"), where("status", "==", "Won"))
      );

      const todayBets = betsSnap.docs
        .map(d => ({ id: d.id, ...d.data() }))
        .filter(b => b.paidAt && isToday(new Date(b.paidAt)));

      /* ===== BUILD STATS (BET 1 TU KWA MTU) ===== */
      const buildUserStats = (list) =>
        list
          .map(u => {
            const userBets = todayBets.filter(b => b.username === u.username);

            if (userBets.length === 0) return null;

            let bestProfit = 0;
            let bestBet = null;

            userBets.forEach(b => {
              const stake =
                b.currency === "TSH"
                  ? Number(b.betInTsh || 0)
                  : Number(b.betInUsdt || 0);

              const payout = Number(b.payout || 0);
              const diff = payout - stake;

              if (diff > bestProfit) {
                bestProfit = diff;
                bestBet = {
                  match: `${b.teamA} vs ${b.teamB}`,
                  stake,
                  payout,
                };
              }
            });

            if (bestProfit <= 0) return null;

            return {
              username: u.username,
              match: bestBet.match,
              stake: bestBet.stake,
              payout: bestBet.payout,
              profit: bestProfit,
            };
          })
          .filter(Boolean);

      const level1Stats = buildUserStats(level1);
      const level2Stats = buildUserStats(level2);
      const level3Stats = buildUserStats(level3);

      const totalProfit =
        [...level1Stats, ...level2Stats, ...level3Stats]
          .reduce((s, u) => s + u.profit, 0);

      setResult({
        level1: level1Stats,
        level2: level2Stats,
        level3: level3Stats,
        totalProfit,
      });
    } catch (e) {
      console.error(e);
      setError("Kuna tatizo wakati wa kutafuta data");
    } finally {
      setLoading(false);
    }
  };

  /* ================= UI ================= */
  return (
    <div style={{ padding: 20 }}>
      <h2>Admin – Team Profit Search (Leo)</h2>

      <div style={{ marginBottom: 15 }}>
        <input
          type="text"
          placeholder="Ingiza username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={{ marginRight: 10 }}
        />
        <button onClick={handleSearch} disabled={loading}>
          {loading ? "Inatafuta..." : "Search"}
        </button>
      </div>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {result && ["level1", "level2", "level3"].map((lvl, i) => (
        <div key={lvl} style={{ marginBottom: 30 }}>
          <h3>Level {i + 1}</h3>
          <p>👥 Idadi ya watu: <strong>{result[lvl].length}</strong></p>

          {result[lvl].length === 0 ? (
            <p>Hakuna waliopata profit leo</p>
          ) : (
            <table border="1" cellPadding="8" width="100%">
              <thead>
                <tr>
                  <th>Username</th>
                  <th>Match</th>
                  <th>Dau</th>
                  <th>Payout</th>
                  <th>Profit</th>
                </tr>
              </thead>
              <tbody>
                {result[lvl].map((u, idx) => (
                  <tr key={idx}>
                    <td>{u.username}</td>
                    <td>{u.match}</td>
                    <td>{u.stake.toLocaleString()}</td>
                    <td>{u.payout.toLocaleString()}</td>
                    <td>{u.profit.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      ))}

      {result && (
        <h3>
          💰 Jumla ya Profit ya Team Leo:{" "}
          <strong>{result.totalProfit.toLocaleString()}</strong>
        </h3>
      )}
    </div>
  );
};

export default AdminTeamProfitSearch;